import { clientsService, providersService, branchesService } from '../../services';

// Server-side search + pagination so every record is reachable in the dropdowns
export const fetchClients = async (query: string, page: number) => {
  return clientsService.getAll({
    filters: query ? { name: { $containsi: query } } : undefined,
    pagination: { page, pageSize: 20 },
    sort: ['name:asc']
  }) as any;
};

export const fetchProviders = async (query: string, page: number) => {
  return providersService.getAll({
    filters: query ? { name: { $containsi: query } } : undefined,
    pagination: { page, pageSize: 20 },
    sort: ['name:asc']
  }) as any;
};

export const fetchBranches = async (query: string, page: number) => {
  return branchesService.getAll({
    filters: query ? { name: { $containsi: query } } : undefined,
    pagination: { page, pageSize: 20 },
    sort: ['name:asc']
  }) as any;
};

export const contractTypeOptions = [
  { value: 'Charter', label: 'Charter (Client)' },
  { value: 'Service', label: 'Service (Client)' },
  { value: 'Supply', label: 'Supply (Supplier)' },
  { value: 'Maintenance', label: 'Maintenance (Supplier)' }
];

export const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' }
];
